// Função para processar texto colado: remove caracteres especiais do início e capitaliza primeira letra
export const processarTextoColado = (texto: string): string => {
  if (!texto) return '';
  
  // Remove espaços e caracteres especiais do início até encontrar a primeira letra
  // Remove qualquer caractere que não seja letra (a-z, A-Z) do início
  const textoLimpo = texto.replace(/^[^a-zA-Z]+/, '');
  
  // Se não houver letras, retorna vazio
  if (!textoLimpo || !/[a-zA-Z]/.test(textoLimpo)) {
    return textoLimpo;
  }
  
  // Capitaliza a primeira letra
  return textoLimpo.charAt(0).toUpperCase() + textoLimpo.slice(1);
};

// Função para processar texto com múltiplos itens separados por ; ou quebras de linha
export const processarTextoMultiploItens = (texto: string): string[] => {
  if (!texto) return [];
  
  // Divide por ponto e vírgula e quebras de linha
  const itens = texto
    .split(/[;\n]/)
    .map(item => item.trim())
    .filter(item => item.length > 0); // Remove linhas vazias
  
  // Processa cada item (remove caracteres especiais do início e capitaliza)
  return itens
    .map(item => processarTextoColado(item))
    .filter(item => item.length > 0); // Remove itens vazios após processamento
};

